// Sendero Provider Portal - Mock Data
// Realistic healthcare data for Austin, TX area

// ─── Members ────────────────────────────────────────────────────────────────

export const members = [
  {
    id: 1,
    memberId: 'SND-100234',
    firstName: 'Elena',
    lastName: 'Vasquez',
    dateOfBirth: '1985-03-14',
    gender: 'Female',
    planName: 'Sendero IdealCare Silver',
    planId: 'SND-SLV-2026',
    status: 'Active',
    eligibilityStart: '2026-01-01',
    eligibilityEnd: '2026-12-31',
    groupNumber: 'GRP-40210',
    subscriberId: 'SUB-100234',
    copay: 35,
    deductible: 4500,
    outOfPocketMax: 8700,
    pcpName: 'Dr. Alan Cooper',
    pcpPhone: '(512) 555-0142',
  },
  {
    id: 2,
    memberId: 'SND-100487',
    firstName: 'Marcus',
    lastName: 'Chen',
    dateOfBirth: '1972-11-02',
    gender: 'Male',
    planName: 'Sendero IdealCare Gold',
    planId: 'SND-GLD-2026',
    status: 'Active',
    eligibilityStart: '2026-01-01',
    eligibilityEnd: '2026-12-31',
    groupNumber: 'GRP-40210',
    subscriberId: 'SUB-100487',
    copay: 25,
    deductible: 2500,
    outOfPocketMax: 6500,
    pcpName: 'Dr. Nina Patel',
    pcpPhone: '(512) 555-0198',
  },
  {
    id: 3,
    memberId: 'SND-100592',
    firstName: 'Priya',
    lastName: 'Sharma',
    dateOfBirth: '1990-07-21',
    gender: 'Female',
    planName: 'Sendero IdealCare Bronze',
    planId: 'SND-BRZ-2026',
    status: 'Active',
    eligibilityStart: '2026-01-01',
    eligibilityEnd: '2026-12-31',
    groupNumber: 'GRP-40315',
    subscriberId: 'SUB-100592',
    copay: 50,
    deductible: 6800,
    outOfPocketMax: 9100,
    pcpName: 'Dr. Alan Cooper',
    pcpPhone: '(512) 555-0142',
  },
  {
    id: 4,
    memberId: 'SND-100678',
    firstName: 'Ryan',
    lastName: 'O\'Brien',
    dateOfBirth: '1968-01-30',
    gender: 'Male',
    planName: 'Sendero IdealCare Silver',
    planId: 'SND-SLV-2026',
    status: 'Terminated',
    eligibilityStart: '2025-01-01',
    eligibilityEnd: '2025-09-15',
    groupNumber: 'GRP-40210',
    subscriberId: 'SUB-100678',
    copay: 35,
    deductible: 4500,
    outOfPocketMax: 8700,
    pcpName: 'Dr. Sam Rivera',
    pcpPhone: '(512) 555-0167',
  },
  {
    id: 5,
    memberId: 'SND-100753',
    firstName: 'Olivia',
    lastName: 'Bennett',
    dateOfBirth: '1995-09-08',
    gender: 'Female',
    planName: 'Sendero IdealCare Gold',
    planId: 'SND-GLD-2026',
    status: 'Active',
    eligibilityStart: '2026-01-01',
    eligibilityEnd: '2026-12-31',
    groupNumber: 'GRP-40315',
    subscriberId: 'SUB-100753',
    copay: 25,
    deductible: 2500,
    outOfPocketMax: 6500,
    pcpName: 'Dr. Nina Patel',
    pcpPhone: '(512) 555-0198',
  },
  {
    id: 6,
    memberId: 'SND-100819',
    firstName: 'Daniel',
    lastName: 'Park',
    dateOfBirth: '1980-12-17',
    gender: 'Male',
    planName: 'Sendero IdealCare Platinum',
    planId: 'SND-PLT-2026',
    status: 'Active',
    eligibilityStart: '2026-01-01',
    eligibilityEnd: '2026-12-31',
    groupNumber: 'GRP-40422',
    subscriberId: 'SUB-100819',
    copay: 15,
    deductible: 1500,
    outOfPocketMax: 4500,
    pcpName: 'Dr. Alan Cooper',
    pcpPhone: '(512) 555-0142',
  },
  {
    id: 7,
    memberId: 'SND-100901',
    firstName: 'Sophia',
    lastName: 'Nakamura',
    dateOfBirth: '1958-04-25',
    gender: 'Female',
    planName: 'Sendero IdealCare Silver',
    planId: 'SND-SLV-2026',
    status: 'Active',
    eligibilityStart: '2026-01-01',
    eligibilityEnd: '2026-12-31',
    groupNumber: 'GRP-40422',
    subscriberId: 'SUB-100901',
    copay: 35,
    deductible: 4500,
    outOfPocketMax: 8700,
    pcpName: 'Dr. Sam Rivera',
    pcpPhone: '(512) 555-0167',
  },
  {
    id: 8,
    memberId: 'SND-101034',
    firstName: 'Ethan',
    lastName: 'Morales',
    dateOfBirth: '1977-06-11',
    gender: 'Male',
    planName: 'Sendero IdealCare Gold',
    planId: 'SND-GLD-2026',
    status: 'Active',
    eligibilityStart: '2026-01-01',
    eligibilityEnd: '2026-12-31',
    groupNumber: 'GRP-40315',
    subscriberId: 'SUB-101034',
    copay: 25,
    deductible: 2500,
    outOfPocketMax: 6500,
    pcpName: 'Dr. Nina Patel',
    pcpPhone: '(512) 555-0198',
  },
  {
    id: 9,
    memberId: 'SND-101122',
    firstName: 'Ava',
    lastName: 'Thompson',
    dateOfBirth: '1993-10-05',
    gender: 'Female',
    planName: 'Sendero IdealCare Bronze',
    planId: 'SND-BRZ-2026',
    status: 'Terminated',
    eligibilityStart: '2025-06-01',
    eligibilityEnd: '2025-12-31',
    groupNumber: 'GRP-40210',
    subscriberId: 'SUB-101122',
    copay: 50,
    deductible: 6800,
    outOfPocketMax: 9100,
    pcpName: 'Dr. Sam Rivera',
    pcpPhone: '(512) 555-0167',
  },
  {
    id: 10,
    memberId: 'SND-101298',
    firstName: 'Nathan',
    lastName: 'Williams',
    dateOfBirth: '1987-02-19',
    gender: 'Male',
    planName: 'Sendero IdealCare Platinum',
    planId: 'SND-PLT-2026',
    status: 'Active',
    eligibilityStart: '2026-01-01',
    eligibilityEnd: '2026-12-31',
    groupNumber: 'GRP-40422',
    subscriberId: 'SUB-101298',
    copay: 15,
    deductible: 1500,
    outOfPocketMax: 4500,
    pcpName: 'Dr. Alan Cooper',
    pcpPhone: '(512) 555-0142',
  },
];

// ─── Invoices ───────────────────────────────────────────────────────────────

export const invoices = [
  {
    id: 1,
    claimNumber: 'CLM-2026-0041',
    description: 'Routine Checkup',
    memberName: 'Elena Vasquez',
    memberId: 'SND-100234',
    amount: 185.00,
    status: 'Paid',
    dateOfService: '2026-02-10',
    dueDate: '2026-03-12',
    billingProviderId: '746000203',
  },
  {
    id: 2,
    claimNumber: 'CLM-2026-0078',
    description: 'Specialist Consultation',
    memberName: 'Marcus Chen',
    memberId: 'SND-100487',
    amount: 320.00,
    status: 'Pending',
    dateOfService: '2026-03-05',
    dueDate: '2026-04-04',
    billingProviderId: '746000203',
  },
  {
    id: 3,
    claimNumber: 'CLM-2026-0112',
    description: 'Diagnostic Lab Work',
    memberName: 'Priya Sharma',
    memberId: 'SND-100592',
    amount: 475.50,
    status: 'Overdue',
    dateOfService: '2026-01-22',
    dueDate: '2026-02-21',
    billingProviderId: '746000203',
  },
  {
    id: 4,
    claimNumber: 'CLM-2026-0156',
    description: 'Physical Therapy Session',
    memberName: 'Daniel Park',
    memberId: 'SND-100819',
    amount: 210.00,
    status: 'Paid',
    dateOfService: '2026-03-18',
    dueDate: '2026-04-17',
    billingProviderId: '746000203',
  },
  {
    id: 5,
    claimNumber: 'CLM-2026-0189',
    description: 'Preventive Screening',
    memberName: 'Olivia Bennett',
    memberId: 'SND-100753',
    amount: 150.00,
    status: 'Pending',
    dateOfService: '2026-03-25',
    dueDate: '2026-04-24',
    billingProviderId: '746000203',
  },
  {
    id: 6,
    claimNumber: 'CLM-2026-0201',
    description: 'Urgent Care Visit',
    memberName: 'Sophia Nakamura',
    memberId: 'SND-100901',
    amount: 425.00,
    status: 'Overdue',
    dateOfService: '2026-01-08',
    dueDate: '2026-02-07',
    billingProviderId: '746000203',
  },
  {
    id: 7,
    claimNumber: 'CLM-2026-0234',
    description: 'Follow-Up Visit',
    memberName: 'Ethan Morales',
    memberId: 'SND-101034',
    amount: 125.00,
    status: 'Paid',
    dateOfService: '2026-03-28',
    dueDate: '2026-04-27',
    billingProviderId: '746000203',
  },
  {
    id: 8,
    claimNumber: 'CLM-2026-0267',
    description: 'Annual Wellness Exam',
    memberName: 'Nathan Williams',
    memberId: 'SND-101298',
    amount: 250.00,
    status: 'Pending',
    dateOfService: '2026-04-02',
    dueDate: '2026-05-02',
    billingProviderId: '746000203',
  },
];

// ─── Payments ───────────────────────────────────────────────────────────────

export const payments = [
  {
    id: 1,
    invoiceId: 1,
    amount: 185.00,
    method: 'EFT',
    status: 'Completed',
    date: '2026-03-10',
    transactionId: 'TXN-20260310-7841',
  },
  {
    id: 2,
    invoiceId: 4,
    amount: 210.00,
    method: 'EFT',
    status: 'Completed',
    date: '2026-04-05',
    transactionId: 'TXN-20260405-3295',
  },
  {
    id: 3,
    invoiceId: 7,
    amount: 125.00,
    method: 'Credit Card',
    status: 'Completed',
    date: '2026-04-08',
    transactionId: 'TXN-20260408-5610',
  },
  {
    id: 4,
    invoiceId: 3,
    amount: 475.50,
    method: 'Check',
    status: 'Failed',
    date: '2026-03-15',
    transactionId: 'TXN-20260315-9023',
  },
  {
    id: 5,
    invoiceId: 2,
    amount: 320.00,
    method: 'Credit Card',
    status: 'Processing',
    date: '2026-04-09',
    transactionId: 'TXN-20260409-1478',
  },
];

// ─── Authorizations ─────────────────────────────────────────────────────────

export const authorizations = [
  {
    id: 1,
    authNumber: 'AUTH-2026-00312',
    memberId: 'SND-100234',
    memberName: 'Elena Vasquez',
    service: 'MRI - Lumbar Spine',
    priority: 'Standard',
    status: 'Approved',
    requestDate: '2026-02-15',
    decisionDate: '2026-02-18',
    expirationDate: '2026-05-18',
    procedureCode: '72148',
    diagnosisCode: 'M54.5',
    notes: 'Approved for single lumbar MRI without contrast. Member reports chronic lower back pain unresponsive to conservative treatment.',
  },
  {
    id: 2,
    authNumber: 'AUTH-2026-00458',
    memberId: 'SND-100487',
    memberName: 'Marcus Chen',
    service: 'Cardiac Stress Test',
    priority: 'Urgent',
    status: 'Approved',
    requestDate: '2026-03-10',
    decisionDate: '2026-03-11',
    expirationDate: '2026-06-11',
    procedureCode: '93015',
    diagnosisCode: 'R00.0',
    notes: 'Urgent authorization granted. Patient presenting with abnormal heart rhythm and exertional chest discomfort.',
  },
  {
    id: 3,
    authNumber: 'AUTH-2026-00521',
    memberId: 'SND-100819',
    memberName: 'Daniel Park',
    service: 'Physical Therapy - 12 Sessions',
    priority: 'Standard',
    status: 'Pending',
    requestDate: '2026-04-01',
    decisionDate: null,
    expirationDate: null,
    procedureCode: '97110',
    diagnosisCode: 'M25.511',
    notes: 'Requesting 12 sessions of therapeutic exercise for right shoulder rehabilitation following rotator cuff strain.',
  },
  {
    id: 4,
    authNumber: 'AUTH-2026-00587',
    memberId: 'SND-100753',
    memberName: 'Olivia Bennett',
    service: 'Outpatient Arthroscopy - Right Knee',
    priority: 'Standard',
    status: 'Denied',
    requestDate: '2026-03-20',
    decisionDate: '2026-03-25',
    expirationDate: null,
    procedureCode: '29881',
    diagnosisCode: 'M23.211',
    notes: 'Denied. Conservative treatment options (physical therapy, NSAIDs) have not been exhausted. Recommend 6 weeks of PT before resubmission.',
  },
  {
    id: 5,
    authNumber: 'AUTH-2026-00634',
    memberId: 'SND-100901',
    memberName: 'Sophia Nakamura',
    service: 'CT Scan - Abdomen and Pelvis',
    priority: 'Urgent',
    status: 'Review',
    requestDate: '2026-04-07',
    decisionDate: null,
    expirationDate: null,
    procedureCode: '74178',
    diagnosisCode: 'R10.9',
    notes: 'Under medical review. Patient age 68 with persistent abdominal pain. Awaiting additional clinical documentation from referring physician.',
  },
  {
    id: 6,
    authNumber: 'AUTH-2026-00690',
    memberId: 'SND-101298',
    memberName: 'Nathan Williams',
    service: 'Sleep Study - Polysomnography',
    priority: 'Standard',
    status: 'Approved',
    requestDate: '2026-03-28',
    decisionDate: '2026-04-02',
    expirationDate: '2026-07-02',
    procedureCode: '95810',
    diagnosisCode: 'G47.33',
    notes: 'Approved for in-lab polysomnography. Patient reports excessive daytime sleepiness, witnessed apneic episodes, and Epworth score of 14.',
  },
];

// ─── Claims ─────────────────────────────────────────────────────────────────

export const claims = [
  {
    id: 1,
    claimNumber: 'CLM-2026-0041',
    memberId: 'SND-100234',
    memberName: 'Elena Vasquez',
    patientAccountNo: 'PA-4821037',
    serviceDate: '2026-02-10',
    status: 'Paid',
    statusDescription: 'Claim Paid in Full',
    billedAmount: 185.00,
    paidAmount: 148.00,
    planPrice: 160.00,
    discountAmount: 25.00,
    memberResponsibility: 12.00,
    checkNumber: 'CHK-90412',
    checkDate: '2026-03-15',
    exCode: '00',
    eopNumber: 'EOP-2026-001847',
    billingProviderId: '746000203',
    providerName: 'Austin Primary Care Associates',
    procedureCode: '99213',
    diagnosisCode: 'Z00.00',
    lineItems: [
      {
        lineNumber: 1,
        serviceDate: '2026-02-10',
        serviceDescription: 'Office Visit - Established Patient',
        procedureCode: '99213',
        modifier: null,
        billedPrice: 185.00,
        paidAmount: 148.00,
        planPrice: 160.00,
        discountAmount: 25.00,
        memberResponsibility: 12.00,
        exCode: '00',
        exDescription: 'Claim Processed as Primary',
      },
    ],
    eopHistory: [
      {
        eopNumber: 'EOP-2026-001847',
        checkNumber: 'CHK-90412',
        checkDate: '2026-03-15',
        paymentAmount: 148.00,
        paymentMethod: 'EFT',
      },
    ],
  },
  {
    id: 2,
    claimNumber: 'CLM-2026-0078',
    memberId: 'SND-100487',
    memberName: 'Marcus Chen',
    patientAccountNo: 'PA-5093218',
    serviceDate: '2026-03-05',
    status: 'Pending',
    statusDescription: 'Pending Medical Review',
    billedAmount: 320.00,
    paidAmount: 0,
    planPrice: 284.00,
    discountAmount: 36.00,
    memberResponsibility: 25.00,
    checkNumber: null,
    checkDate: null,
    exCode: 'A1',
    eopNumber: null,
    billingProviderId: '746000203',
    providerName: 'Austin Primary Care Associates',
    procedureCode: '99243',
    diagnosisCode: 'R00.0',
    lineItems: [
      {
        lineNumber: 1,
        serviceDate: '2026-03-05',
        serviceDescription: 'Consultation - New Patient, Moderate Complexity',
        procedureCode: '99243',
        modifier: '25',
        billedPrice: 245.00,
        paidAmount: 0,
        planPrice: 218.00,
        discountAmount: 27.00,
        memberResponsibility: 25.00,
        exCode: 'A1',
        exDescription: 'Claim/Encounter Forwarded to Payer for Adjudication',
      },
      {
        lineNumber: 2,
        serviceDate: '2026-03-05',
        serviceDescription: 'Electrocardiogram, 12-Lead',
        procedureCode: '93000',
        modifier: null,
        billedPrice: 75.00,
        paidAmount: 0,
        planPrice: 66.00,
        discountAmount: 9.00,
        memberResponsibility: 0,
        exCode: 'A1',
        exDescription: 'Claim/Encounter Forwarded to Payer for Adjudication',
      },
    ],
    eopHistory: [],
  },
  {
    id: 3,
    claimNumber: 'CLM-2026-0112',
    memberId: 'SND-100592',
    memberName: 'Priya Sharma',
    patientAccountNo: 'PA-3274619',
    serviceDate: '2026-01-22',
    status: 'Denied',
    statusDescription: 'Denied - Missing Modifier',
    billedAmount: 475.50,
    paidAmount: 0,
    planPrice: 412.00,
    discountAmount: 63.50,
    memberResponsibility: 0,
    checkNumber: null,
    checkDate: null,
    exCode: 'N16',
    eopNumber: null,
    billingProviderId: '746000203',
    providerName: 'Austin Primary Care Associates',
    procedureCode: '80053',
    diagnosisCode: 'R73.03',
    lineItems: [
      {
        lineNumber: 1,
        serviceDate: '2026-01-22',
        serviceDescription: 'Comprehensive Metabolic Panel',
        procedureCode: '80053',
        modifier: null,
        billedPrice: 195.50,
        paidAmount: 0,
        planPrice: 168.00,
        discountAmount: 27.50,
        memberResponsibility: 0,
        exCode: 'N16',
        exDescription: 'Missing/Incomplete/Invalid Modifier',
      },
      {
        lineNumber: 2,
        serviceDate: '2026-01-22',
        serviceDescription: 'Lipid Panel',
        procedureCode: '80061',
        modifier: null,
        billedPrice: 145.00,
        paidAmount: 0,
        planPrice: 126.00,
        discountAmount: 19.00,
        memberResponsibility: 0,
        exCode: 'N16',
        exDescription: 'Missing/Incomplete/Invalid Modifier',
      },
      {
        lineNumber: 3,
        serviceDate: '2026-01-22',
        serviceDescription: 'Hemoglobin A1c',
        procedureCode: '83036',
        modifier: null,
        billedPrice: 135.00,
        paidAmount: 0,
        planPrice: 118.00,
        discountAmount: 17.00,
        memberResponsibility: 0,
        exCode: 'N16',
        exDescription: 'Missing/Incomplete/Invalid Modifier',
      },
    ],
    eopHistory: [],
  },
  {
    id: 4,
    claimNumber: 'CLM-2026-0156',
    memberId: 'SND-100819',
    memberName: 'Daniel Park',
    patientAccountNo: 'PA-6185402',
    serviceDate: '2026-03-18',
    status: 'Paid',
    statusDescription: 'Claim Paid - Patient Responsibility Applied',
    billedAmount: 210.00,
    paidAmount: 163.00,
    planPrice: 185.00,
    discountAmount: 25.00,
    memberResponsibility: 22.00,
    checkNumber: 'CHK-90578',
    checkDate: '2026-03-28',
    exCode: '00',
    eopNumber: 'EOP-2026-002103',
    billingProviderId: '746000203',
    providerName: 'Austin Primary Care Associates',
    procedureCode: '97110',
    diagnosisCode: 'M25.511',
    lineItems: [
      {
        lineNumber: 1,
        serviceDate: '2026-03-18',
        serviceDescription: 'Therapeutic Exercises - Right Shoulder',
        procedureCode: '97110',
        modifier: 'GP',
        billedPrice: 130.00,
        paidAmount: 101.00,
        planPrice: 115.00,
        discountAmount: 15.00,
        memberResponsibility: 14.00,
        exCode: '00',
        exDescription: 'Claim Processed as Primary',
      },
      {
        lineNumber: 2,
        serviceDate: '2026-03-18',
        serviceDescription: 'Manual Therapy Techniques',
        procedureCode: '97140',
        modifier: 'GP',
        billedPrice: 80.00,
        paidAmount: 62.00,
        planPrice: 70.00,
        discountAmount: 10.00,
        memberResponsibility: 8.00,
        exCode: '00',
        exDescription: 'Claim Processed as Primary',
      },
    ],
    eopHistory: [
      {
        eopNumber: 'EOP-2026-002103',
        checkNumber: 'CHK-90578',
        checkDate: '2026-03-28',
        paymentAmount: 163.00,
        paymentMethod: 'EFT',
      },
    ],
  },
  {
    id: 5,
    claimNumber: 'CLM-2026-0189',
    memberId: 'SND-100753',
    memberName: 'Olivia Bennett',
    patientAccountNo: 'PA-7539841',
    serviceDate: '2026-03-25',
    status: 'Pending',
    statusDescription: 'Pending - Awaiting Clinical Documentation',
    billedAmount: 150.00,
    paidAmount: 0,
    planPrice: 132.00,
    discountAmount: 18.00,
    memberResponsibility: 25.00,
    checkNumber: null,
    checkDate: null,
    exCode: 'B2',
    eopNumber: null,
    billingProviderId: '746000203',
    providerName: 'Austin Primary Care Associates',
    procedureCode: '99395',
    diagnosisCode: 'Z00.00',
    lineItems: [
      {
        lineNumber: 1,
        serviceDate: '2026-03-25',
        serviceDescription: 'Preventive Visit - Established Patient, 18-39',
        procedureCode: '99395',
        modifier: null,
        billedPrice: 150.00,
        paidAmount: 0,
        planPrice: 132.00,
        discountAmount: 18.00,
        memberResponsibility: 25.00,
        exCode: 'B2',
        exDescription: 'Additional Documentation Required',
      },
    ],
    eopHistory: [],
  },
  {
    id: 6,
    claimNumber: 'CLM-2026-0201',
    memberId: 'SND-100901',
    memberName: 'Sophia Nakamura',
    patientAccountNo: 'PA-2947563',
    serviceDate: '2026-01-08',
    status: 'Paid',
    statusDescription: 'Claim Paid in Full',
    billedAmount: 425.00,
    paidAmount: 355.00,
    planPrice: 390.00,
    discountAmount: 35.00,
    memberResponsibility: 35.00,
    checkNumber: 'CHK-90301',
    checkDate: '2026-02-12',
    exCode: '00',
    eopNumber: 'EOP-2026-001592',
    billingProviderId: '746000203',
    providerName: 'Austin Primary Care Associates',
    procedureCode: '99283',
    diagnosisCode: 'R10.9',
    lineItems: [
      {
        lineNumber: 1,
        serviceDate: '2026-01-08',
        serviceDescription: 'Emergency Dept Visit - Moderate Severity',
        procedureCode: '99283',
        modifier: null,
        billedPrice: 310.00,
        paidAmount: 258.00,
        planPrice: 285.00,
        discountAmount: 25.00,
        memberResponsibility: 27.00,
        exCode: '00',
        exDescription: 'Claim Processed as Primary',
      },
      {
        lineNumber: 2,
        serviceDate: '2026-01-08',
        serviceDescription: 'Urinalysis, Automated with Microscopy',
        procedureCode: '81001',
        modifier: null,
        billedPrice: 115.00,
        paidAmount: 97.00,
        planPrice: 105.00,
        discountAmount: 10.00,
        memberResponsibility: 8.00,
        exCode: '00',
        exDescription: 'Claim Processed as Primary',
      },
    ],
    eopHistory: [
      {
        eopNumber: 'EOP-2026-001592',
        checkNumber: 'CHK-90301',
        checkDate: '2026-02-12',
        paymentAmount: 355.00,
        paymentMethod: 'EFT',
      },
    ],
  },
  {
    id: 7,
    claimNumber: 'CLM-2026-0234',
    memberId: 'SND-101034',
    memberName: 'Ethan Morales',
    patientAccountNo: 'PA-8416230',
    serviceDate: '2026-03-28',
    status: 'Review',
    statusDescription: 'Under Clinical Review',
    billedAmount: 125.00,
    paidAmount: 0,
    planPrice: 108.00,
    discountAmount: 17.00,
    memberResponsibility: 25.00,
    checkNumber: null,
    checkDate: null,
    exCode: 'A1',
    eopNumber: null,
    billingProviderId: '746000203',
    providerName: 'Austin Primary Care Associates',
    procedureCode: '99214',
    diagnosisCode: 'J06.9',
    lineItems: [
      {
        lineNumber: 1,
        serviceDate: '2026-03-28',
        serviceDescription: 'Office Visit - Established Patient, Moderate Complexity',
        procedureCode: '99214',
        modifier: null,
        billedPrice: 125.00,
        paidAmount: 0,
        planPrice: 108.00,
        discountAmount: 17.00,
        memberResponsibility: 25.00,
        exCode: 'A1',
        exDescription: 'Claim/Encounter Under Review',
      },
    ],
    eopHistory: [],
  },
  {
    id: 8,
    claimNumber: 'CLM-2026-0267',
    memberId: 'SND-101298',
    memberName: 'Nathan Williams',
    patientAccountNo: 'PA-1058374',
    serviceDate: '2026-04-02',
    status: 'Pending',
    statusDescription: 'Pending - Awaiting Provider Verification',
    billedAmount: 250.00,
    paidAmount: 0,
    planPrice: 218.00,
    discountAmount: 32.00,
    memberResponsibility: 15.00,
    checkNumber: null,
    checkDate: null,
    exCode: 'B2',
    eopNumber: null,
    billingProviderId: '746000203',
    providerName: 'Austin Primary Care Associates',
    procedureCode: '99396',
    diagnosisCode: 'Z00.00',
    lineItems: [
      {
        lineNumber: 1,
        serviceDate: '2026-04-02',
        serviceDescription: 'Preventive Visit - Established Patient, 40-64',
        procedureCode: '99396',
        modifier: null,
        billedPrice: 175.00,
        paidAmount: 0,
        planPrice: 152.00,
        discountAmount: 23.00,
        memberResponsibility: 15.00,
        exCode: 'B2',
        exDescription: 'Additional Documentation Required',
      },
      {
        lineNumber: 2,
        serviceDate: '2026-04-02',
        serviceDescription: 'Venipuncture for Lab Draw',
        procedureCode: '36415',
        modifier: null,
        billedPrice: 25.00,
        paidAmount: 0,
        planPrice: 22.00,
        discountAmount: 3.00,
        memberResponsibility: 0,
        exCode: 'B2',
        exDescription: 'Additional Documentation Required',
      },
      {
        lineNumber: 3,
        serviceDate: '2026-04-02',
        serviceDescription: 'Complete Blood Count with Differential',
        procedureCode: '85025',
        modifier: null,
        billedPrice: 50.00,
        paidAmount: 0,
        planPrice: 44.00,
        discountAmount: 6.00,
        memberResponsibility: 0,
        exCode: 'B2',
        exDescription: 'Additional Documentation Required',
      },
    ],
    eopHistory: [],
  },
];

// ─── Portal Users ───────────────────────────────────────────────────────────

export const portalUsers = [
  {
    id: 1,
    firstName: 'Rachel',
    lastName: 'Klein',
    email: 'r.klein@austinprimarycare.com',
    phone: '(512) 555-0301',
    role: 'Admin',
    status: 'Active',
    lastLogin: '2026-04-10T08:15:00',
    createdAt: '2024-06-15T10:00:00',
  },
  {
    id: 2,
    firstName: 'Dr. Alan',
    lastName: 'Cooper',
    email: 'a.cooper@austinprimarycare.com',
    phone: '(512) 555-0142',
    role: 'Provider',
    status: 'Active',
    lastLogin: '2026-04-09T14:32:00',
    createdAt: '2024-06-15T10:00:00',
  },
  {
    id: 3,
    firstName: 'Dr. Nina',
    lastName: 'Patel',
    email: 'n.patel@austinprimarycare.com',
    phone: '(512) 555-0198',
    role: 'Provider',
    status: 'Active',
    lastLogin: '2026-04-10T07:45:00',
    createdAt: '2024-08-01T09:30:00',
  },
  {
    id: 4,
    firstName: 'Maya',
    lastName: 'Scott',
    email: 'm.scott@austinprimarycare.com',
    phone: '(512) 555-0355',
    role: 'Staff',
    status: 'Active',
    lastLogin: '2026-04-08T16:20:00',
    createdAt: '2025-01-10T11:00:00',
  },
  {
    id: 5,
    firstName: 'Kyle',
    lastName: 'Adams',
    email: 'k.adams@austinprimarycare.com',
    phone: '(512) 555-0378',
    role: 'Staff',
    status: 'Inactive',
    lastLogin: '2026-02-14T09:10:00',
    createdAt: '2025-03-22T14:00:00',
  },
  {
    id: 6,
    firstName: 'Dana',
    lastName: 'Hughes',
    email: 'd.hughes@austinprimarycare.com',
    phone: '(512) 555-0390',
    role: 'Viewer',
    status: 'Active',
    lastLogin: '2026-04-07T11:05:00',
    createdAt: '2025-09-01T08:45:00',
  },
];

// ─── Notifications ──────────────────────────────────────────────────────────

export const notifications = [
  {
    id: 1,
    title: 'Claim CLM-2026-0112 Denied',
    message: 'Claim for Priya Sharma (diagnostic lab work) has been denied. Missing modifier on procedure code 80053. Please review and resubmit.',
    type: 'claim',
    read: false,
    date: '2026-04-09T10:30:00',
  },
  {
    id: 2,
    title: 'Authorization AUTH-2026-00521 Awaiting Review',
    message: 'Prior authorization request for Daniel Park (physical therapy, 12 sessions) is pending. Expected decision within 3 business days.',
    type: 'auth',
    read: false,
    date: '2026-04-08T14:15:00',
  },
  {
    id: 3,
    title: 'Invoice Overdue - CLM-2026-0201',
    message: 'Payment for Sophia Nakamura urgent care visit ($425.00) is past due. Original due date was 02/07/2026. Please remit payment to avoid collections.',
    type: 'invoice',
    read: true,
    date: '2026-04-05T09:00:00',
  },
  {
    id: 4,
    title: 'Scheduled Maintenance - April 12',
    message: 'The Sendero Provider Portal will undergo scheduled maintenance on April 12, 2026 from 2:00 AM to 5:00 AM CT. Services may be intermittently unavailable.',
    type: 'system',
    read: false,
    date: '2026-04-04T16:00:00',
  },
  {
    id: 5,
    title: 'Payment Received - CLM-2026-0234',
    message: 'EFT payment of $125.00 for Ethan Morales follow-up visit has been processed successfully. Transaction ID: TXN-20260408-5610.',
    type: 'invoice',
    read: true,
    date: '2026-04-08T11:45:00',
  },
];

// ─── Dashboard Stats ────────────────────────────────────────────────────────

export const dashboardStats = {
  activeMembers: 8,
  pendingClaims: 3,
  openAuthorizations: 2,
  outstandingInvoices: 2,
  totalPaidThisMonth: 520.00,
  claimApprovalRate: 75,
};


// ─── Organizations (Super Admin View) ───────────────────────────────────────

export const organizations = [
    { id: 'ORG-001', name: 'Austin Primary Care', city: 'Austin', state: 'TX', npi: '1234567890' },
    { id: 'ORG-002', name: 'Cedar Park Medical Group', city: 'Cedar Park', state: 'TX', npi: '2345678901' },
    { id: 'ORG-003', name: 'Round Rock Family Health', city: 'Round Rock', state: 'TX', npi: '3456789012' },
    { id: 'ORG-004', name: 'San Marcos Community Clinic', city: 'San Marcos', state: 'TX', npi: '4567890123' },
    { id: 'ORG-005', name: 'Georgetown Wellness Center', city: 'Georgetown', state: 'TX', npi: '5678901234' },
];

// ─── System Users (Super Admin - All Organizations) ──────────────────────────

export const systemUsers = [
    // Organization 1: Austin Primary Care (original 6 users)
    { id: 1, firstName: 'Rachel', lastName: 'Klein', email: 'r.klein@austinprimarycare.com', phone: '(512) 555-0301', role: 'Super Admin', status: 'Active', lastLogin: '2026-04-10T08:15:00', createdAt: '2024-06-15T10:00:00', organizationId: 'ORG-001', organizationName: 'Austin Primary Care' },
    { id: 2, firstName: 'Dr. Alan', lastName: 'Cooper', email: 'a.cooper@austinprimarycare.com', phone: '(512) 555-0142', role: 'Provider', status: 'Active', lastLogin: '2026-04-09T14:32:00', createdAt: '2024-03-20T09:30:00', organizationId: 'ORG-001', organizationName: 'Austin Primary Care' },
    { id: 3, firstName: 'Dr. Nina', lastName: 'Patel', email: 'n.patel@austinprimarycare.com', phone: '(512) 555-0198', role: 'Provider', status: 'Active', lastLogin: '2026-04-10T07:45:00', createdAt: '2024-04-12T11:00:00', organizationId: 'ORG-001', organizationName: 'Austin Primary Care' },
    { id: 4, firstName: 'Maya', lastName: 'Scott', email: 'm.scott@austinprimarycare.com', phone: '(512) 555-0355', role: 'Staff', status: 'Active', lastLogin: '2026-04-08T16:20:00', createdAt: '2025-01-08T14:15:00', organizationId: 'ORG-001', organizationName: 'Austin Primary Care' },
    { id: 5, firstName: 'Kyle', lastName: 'Adams', email: 'k.adams@austinprimarycare.com', phone: '(512) 555-0378', role: 'Staff', status: 'Inactive', lastLogin: '2026-02-14T09:10:00', createdAt: '2024-11-02T13:20:00', organizationId: 'ORG-001', organizationName: 'Austin Primary Care' },
    { id: 6, firstName: 'Dana', lastName: 'Hughes', email: 'd.hughes@austinprimarycare.com', phone: '(512) 555-0390', role: 'Viewer', status: 'Active', lastLogin: '2026-04-07T11:05:00', createdAt: '2025-09-01T08:45:00', organizationId: 'ORG-001', organizationName: 'Austin Primary Care' },

    // Organization 2: Cedar Park Medical Group (5 users)
    { id: 7, firstName: 'Marcus', lastName: 'Chen', email: 'm.chen@cedarparkmed.com', phone: '(512) 555-0412', role: 'Admin', status: 'Active', lastLogin: '2026-04-10T09:22:00', createdAt: '2024-02-10T10:30:00', organizationId: 'ORG-002', organizationName: 'Cedar Park Medical Group' },
    { id: 8, firstName: 'Dr. Priya', lastName: 'Sharma', email: 'p.sharma@cedarparkmed.com', phone: '(512) 555-0445', role: 'Provider', status: 'Active', lastLogin: '2026-04-09T15:48:00', createdAt: '2024-05-22T11:15:00', organizationId: 'ORG-002', organizationName: 'Cedar Park Medical Group' },
    { id: 9, firstName: 'Dr. Elena', lastName: 'Vasquez', email: 'e.vasquez@cedarparkmed.com', phone: '(512) 555-0467', role: 'Provider', status: 'Active', lastLogin: '2026-04-10T08:55:00', createdAt: '2024-07-18T14:00:00', organizationId: 'ORG-002', organizationName: 'Cedar Park Medical Group' },
    { id: 10, firstName: 'Tyler', lastName: 'Brooks', email: 't.brooks@cedarparkmed.com', phone: '(512) 555-0489', role: 'Staff', status: 'Active', lastLogin: '2026-04-09T10:15:00', createdAt: '2025-03-05T09:45:00', organizationId: 'ORG-002', organizationName: 'Cedar Park Medical Group' },
    { id: 11, firstName: 'Sophia', lastName: 'Nakamura', email: 's.nakamura@cedarparkmed.com', phone: '(512) 555-0501', role: 'Viewer', status: 'Active', lastLogin: '2026-04-08T13:30:00', createdAt: '2025-06-14T11:20:00', organizationId: 'ORG-002', organizationName: 'Cedar Park Medical Group' },

    // Organization 3: Round Rock Family Health (4 users)
    { id: 12, firstName: 'Jennifer', lastName: 'Holloway', email: 'j.holloway@roundrockfamily.com', phone: '(512) 555-0612', role: 'Admin', status: 'Active', lastLogin: '2026-04-10T07:30:00', createdAt: '2024-01-15T10:00:00', organizationId: 'ORG-003', organizationName: 'Round Rock Family Health' },
    { id: 13, firstName: 'Dr. Ravi', lastName: 'Iyer', email: 'r.iyer@roundrockfamily.com', phone: '(512) 555-0645', role: 'Provider', status: 'Active', lastLogin: '2026-04-09T16:10:00', createdAt: '2024-04-08T13:45:00', organizationId: 'ORG-003', organizationName: 'Round Rock Family Health' },
    { id: 14, firstName: 'Dr. Anaya', lastName: 'Okonkwo', email: 'a.okonkwo@roundrockfamily.com', phone: '(512) 555-0667', role: 'Provider', status: 'Inactive', lastLogin: '2026-01-22T11:00:00', createdAt: '2024-08-12T09:30:00', organizationId: 'ORG-003', organizationName: 'Round Rock Family Health' },
    { id: 15, firstName: 'Brandon', lastName: 'Mitchell', email: 'b.mitchell@roundrockfamily.com', phone: '(512) 555-0689', role: 'Staff', status: 'Active', lastLogin: '2026-04-10T08:00:00', createdAt: '2025-02-18T14:15:00', organizationId: 'ORG-003', organizationName: 'Round Rock Family Health' },

    // Organization 4: San Marcos Community Clinic (4 users)
    { id: 16, firstName: 'Devon', lastName: 'Washington', email: 'd.washington@sanmarcosclinic.org', phone: '(512) 555-0712', role: 'Super Admin', status: 'Active', lastLogin: '2026-04-10T09:45:00', createdAt: '2023-11-20T10:15:00', organizationId: 'ORG-004', organizationName: 'San Marcos Community Clinic' },
    { id: 17, firstName: 'Dr. Chloe', lastName: 'Rasmussen', email: 'c.rasmussen@sanmarcosclinic.org', phone: '(512) 555-0745', role: 'Provider', status: 'Active', lastLogin: '2026-04-09T14:25:00', createdAt: '2024-03-14T11:30:00', organizationId: 'ORG-004', organizationName: 'San Marcos Community Clinic' },
    { id: 18, firstName: 'Isabella', lastName: 'Romano', email: 'i.romano@sanmarcosclinic.org', phone: '(512) 555-0767', role: 'Staff', status: 'Active', lastLogin: '2026-04-08T10:50:00', createdAt: '2025-04-02T13:00:00', organizationId: 'ORG-004', organizationName: 'San Marcos Community Clinic' },
    { id: 19, firstName: 'Omar', lastName: 'Hassan', email: 'o.hassan@sanmarcosclinic.org', phone: '(512) 555-0789', role: 'Viewer', status: 'Active', lastLogin: '2026-04-07T15:20:00', createdAt: '2025-07-11T09:15:00', organizationId: 'ORG-004', organizationName: 'San Marcos Community Clinic' },

    // Organization 5: Georgetown Wellness Center (3 users)
    { id: 20, firstName: 'Lauren', lastName: 'Whitaker', email: 'l.whitaker@georgetownwellness.com', phone: '(512) 555-0812', role: 'Admin', status: 'Active', lastLogin: '2026-04-10T08:40:00', createdAt: '2024-05-30T10:45:00', organizationId: 'ORG-005', organizationName: 'Georgetown Wellness Center' },
    { id: 21, firstName: 'Dr. Samuel', lastName: 'Okafor', email: 's.okafor@georgetownwellness.com', phone: '(512) 555-0845', role: 'Provider', status: 'Active', lastLogin: '2026-04-09T11:55:00', createdAt: '2024-09-18T14:30:00', organizationId: 'ORG-005', organizationName: 'Georgetown Wellness Center' },
    { id: 22, firstName: 'Aiden', lastName: 'Peterson', email: 'a.peterson@georgetownwellness.com', phone: '(512) 555-0867', role: 'Staff', status: 'Active', lastLogin: '2026-04-08T09:15:00', createdAt: '2025-08-22T11:00:00', organizationId: 'ORG-005', organizationName: 'Georgetown Wellness Center' },
];

// ─── Notifications ──────────────────────────────────────────────────────────

